import { useNavigator } from '@repo/toolkit/use-navigator'
import { ActivityIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createActivity } from '../../../api/ols/activities/create-activity'
import UserNavBar from '../../../components/elements/nav-bar'
import ActivityForm from '../../../components/pages/ols/activity/activity-form'
import { Paths } from '../../../lib/constants/path'
import useAuth from '../../../lib/hooks/use-auth'
import { CurrencyEnum } from '../../../lib/types/enums/common/currency.enum'
import { twoButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'

const ActivityCreatePage = () => {
  const { user } = useAuth()
  const { back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createActivity,
    onError: showAxiosError,
    onSuccess: () => toast.success('Activity created successfully')
  })

  const olId = user?.ol?.id
  const currency = user?.ol?.currency ?? CurrencyEnum.EUR

  if (!olId) return null

  return (
    <div>
      <UserNavBar title={'Add activity'} icon={ActivityIcon} />
      <div className={'h-4'} />
      <ActivityForm
        currency={currency}
        defaultValues={{ activitySplitAge: 16, transportSplitAge: 16 }}
        buttonsConfig={twoButtonsConfig({
          confirmText: 'Confirm',
          onCancel: () => back(Paths.OL_PERSONAL_SPACE_ACTIVITY_LIST_PAGE),
          onConfirm: async (values) => {
            await mutateAsync({ ...values, olId })
            back(Paths.OL_PERSONAL_SPACE_ACTIVITY_LIST_PAGE)
          },
          isEnglish: true
        })}
      />
    </div>
  )
}

export default ActivityCreatePage
